import API from '@/api/api.js'
import Moment from 'moment';
import Qs from 'qs'

export default class HomeAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

 // New Functions for Biotrue CMS

 getStaticStoreList(params, success, error) {
    this.api.get('/store/getStaticList', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


 createStaticStore(params, success, error) {
    this.api.post('/store/createStaticStore', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

 updateStaticStore(params, success, error) {
    this.api.post('/store/updateStaticStore', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // Update Version of Static Store
 deleteStaticStore(params, success, error) {
    this.api.post('/store/deleteStaticStore', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  // Export Store List function for Static B and Static C
  exportStaticStore(param, success, error) {
    // let code ='2SF945XC!@SDF34';
    var url = this.api.domain + '/store/'+param['key']+'?code=' + param['code'] ;
    var win = window.open(url, '_blank');
    if (win) {
      //Browser has allowed it to be opened
      win.focus();
    } else {
      //Browser has blocked it
      alert('Please allow "Popup Window" for document downloading');
    }
  }

// Send SMS
    sendSMS(params, success, error){
      this.api.sendSMS(params.telephone, params.content, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
    }


  // getMerchantList

    getMerchantList(params, success, error) {
    this.api.get('/auth/getMerchantList', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // createMerchant
    createMerchant(params, success, error) {
    this.api.post('/auth/multiRegister', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


    getStoreList(params, success, error) {
    this.api.get('/store/getList', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  // createStore
    createStore(params, success, error) {
    this.api.post('/store/createStore', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // updateStore
     updateStore(params, success, error) {
    this.api.post('/store/updateStore', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  // deleteStore
     deleteStore(params, success, error) {
    this.api.post('/store/delete', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  
  getRegistrationList(params, success, error) {
    this.api.get('/registration/getList', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


getBISelections(params, success, error) {
    this.api.get(`/selection/${params}`, {}, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  redeemBIRecord(param, success, error) {
    this.api.post('/registration/redeem', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  deleteBIRecord(param, success, error) {
    this.api.post('/registration/delete', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  BIExportCSV(param, success, error) {
    let code ='2SF945XC!@SDF34';
    var url = this.api.domain + '/'+param['type']+'/export?code=' + code + '&phase='+param['phase'];
    var win = window.open(url, '_blank');
    if (win) {
      //Browser has allowed it to be opened
      win.focus();
    } else {
      //Browser has blocked it
      alert('Please allow "Popup Window" for document downloading');
    }

    // this.api.get('/registration/export', {code:'2SF945XC!@SDF34'}, (json) => {
    //   success(json);
    // }, (err) => {
    //   error(err);
    // });
  }

// Redemption Part
    getRedemptionList(params, success, error) {
    this.api.get('/redemption/getList', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteRedemptionRecord(param, success, error) {
    this.api.post('/redemption/delete', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }












  getRenewalList(param, success, error) {
    this.api.get('/renewal', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getBirthdayList(param, success, error) {
    var param = {
      ...param,
      months: 12
    }
    this.api.get('/home/birthday', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getMessageList(param, success, error) {
    this.api.get('/home/message', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getBulletinList(param, success, error) {
    this.api.get('/home/bulletin', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getBulletinDetail(param, success, error) {
    this.api.get('/home/bulletin/detail', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getDashboardCharts(param, success, error) {
    this.api.get('/home/dashboard', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getCustomerPolicyList(params, success, error) {
    this.api.get('/customer/policy', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCaseTrendChart(params, success, error) {
    this.api.get('/home/dashboard/caseTrend', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getFycTrendChart(params, success, error) {
    this.api.get('/home/dashboard/fycTrend', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCommTrendChart(params, success, error) {
    this.api.get('/home/dashboard/commissionTrend', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }




}



// WEBPACK FOOTER //
// ./src/api/Home/apiList.js